const initialState = {
  alerts: [],
  muteAlerts: [],
  adminMuteAlerts: [],
};

export const AlertReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALERTS':
      return {
        ...state,
        alerts: action.payload,
      };
    case 'GET_EDITED_ALERTS':
      return {
        ...state,
        editedAlert: action.payload,
      };
    case 'DELETE_ALERTS':
      return {
        ...state,
        deleteAlert: action.payload,
      };
    case 'MUTE_ALERT':
      return {
        ...state,
        muteAlerts: action.payload,
      };
    case 'GET_ADMIN_ALERTS':
      return {
        ...state,
        adminAlerts: action.payload,
      };
    case 'DELETE_ADMIN_ALERTS':
      return {
        ...state,
        adminDeletedAlerts: action.payload,
      };
    case 'GET_EDITED_ADMIN_ALERTS':
      return {
        ...state,
        adminEditedAlerts: action.payload,
      };
    case 'MUTE_ADMIN_ALERT':
      return {
        ...state,
        adminMuteAlerts: action.payload,
      };
    case 'CREATE_ALERT':
      return {
        ...state,
        createAlert: action.payload,
      };
    case 'CREATE_ADMIN_ALERT':
      return {
        ...state,
        createAdminAlert: action.payload,
      };
    case 'ERROR_CREATE_ALERT':
      return {
        ...state,
        errorCreateAlert: action.payload,
      };
    case 'API_START':
      if (action.payload === 'GET_ALL_ALERTS') {
        return {
          ...state,
          isLoadingPeopleLeaderAlerts: true,
        };
      } else if (action.payload === 'GET_ALL_ADMIN_ALERTS') {
        return {
          ...state,
          isLoadingAdminAlerts: true,
        };
      } else if (action.payload === 'MUTE_ALERTS') {
        return {
          ...state,
          isLoadingMutePeopleLeaderAlerts: true,
        };
      } else if (action.payload === 'MUTE_ADMIN_ALERTS') {
        return {
          ...state,
          isLoadingAdminMuteAlerts: true,
        };
      } else if (action.payload === 'DELETE_ADMIN_ALERT') {
        return {
          ...state,
          isLoadingDeleteAdminAlerts: true,
        }
      } else if (action.payload === 'DELETE_ALERT') {
        return {
          ...state,
          isLoadingDeleteAlerts: true,
        }
      }
      else {
        return state;
      }

    case 'API_END':
      if (action.payload === 'GET_ALL_ALERTS') {
        return {
          ...state,
          isLoadingPeopleLeaderAlerts: false,
        };
      } else if (action.payload === 'GET_ALL_ADMIN_ALERTS') {
        return {
          ...state,
          isLoadingAdminAlerts: false,
        };
      } else if (action.payload === 'MUTE_ALERTS') {
        return {
          ...state,
          isLoadingMutePeopleLeaderAlerts: false,
        };
      } else if (action.payload === 'MUTE_ADMIN_ALERTS') {
        return {
          ...state,
          isLoadingAdminMuteAlerts: false,
        };
      } else if (action.payload === 'DELETE_ADMIN_ALERT') {
        return {
          ...state,
          isLoadingDeleteAdminAlerts: false,
        }
      } else if (action.payload === 'DELETE_ALERT') {
        return {
          ...state,
          isLoadingDeleteAlerts: false,
        }
      } else {
        return state;
      }

    default:
      return state;
  }
};
